import { render } from "./QuickpayPaymentCard.vue?vue&type=template&id=288b93f6&scoped=true"
import script from "./QuickpayPaymentCard.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentCard.vue?vue&type=script&lang=js"

import "./QuickpayPaymentCard.vue?vue&type=style&index=0&id=288b93f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288b93f6"]])

export default __exports__